import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Stepper, Step, StepLabel } from "@material-ui/core";

function RedStepIcon(props) {
  const { active, completed } = props;

  let color = "#cfd8dc";
  if (active) color = "#F72717";
  if (completed) color = "#1E293B";
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 24,
        width: 24,
      }}
    >
      <span
        style={{
          background: color,
          borderRadius: "50%",
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 700,
          fontSize: "14px",
        }}
      >
        {completed ? "✓" : props.icon}
      </span>
    </span>
  );
}

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    backgroundColor: "#FFF",
    padding: "1rem",
    borderRadius: "20px",
    boxShadow: "0px 0px 5px -4px rgba(0,0,0, 0.5)",
  },
  stepper: {
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "transparent",
  },
  label: {
    color: "black !important",
  },
  activeStep: {
    "& .MuiStepLabel-label": {
      color: "#F72717",
      fontWeight: "bold",
    },
    completedStep: {
      "& .MuiStepLabel-label": {
        color: "#1E293B",
        fontWeight: "bold",
      },
    },
  },
}));

export function StepperWrapper(props) {
  const classes = useStyles();

  function onClickStep(step) {
    props.onClickStep(step);
  }

  const { currentStep, steppers, children, hideStepper } = props;

  return (
    <Box className={classes.stepperContainer}>
      {!hideStepper && (<Stepper
        className={classes.stepper}
        alternativeLabel
        activeStep={currentStep?.id}
      >
        {steppers.map((step) => (
          <Step
            key={step.id}
            onClick={() => onClickStep(step)}
            className={currentStep?.id === step.id ? classes.activeStep : ""}
          >
            <StepLabel
              active={currentStep?.id === step.id}
              completed={currentStep?.id > step.id}
              StepIconComponent={RedStepIcon}
              classes={{ label: classes.label }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      )}
      <Box>{children}</Box>
    </Box>
  );
}
